import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import RadioForm, {
  RadioButton,
  RadioButtonInput,
  RadioButtonLabel,
} from "react-native-simple-radio-button";
import CaretIcon from "@assets/svg/Caret";
import CheckIcon from "@assets/svg/CheckGreen";
import colors from "@constants/color";
import t from "@constants/localization";
import Photo from "./Photo";
import Comment from "./Comment";

const PATH = "screens/KYCSetup/AddressSection";

const AddressSection = (props) => {
  const {
    userAddress = "",
    navigateToTLAddress = () => {},
    sameAddress,
    setSameAddress,

    addressPhoto,
    uploadAddressProof,
    removeAddressProof,
    disableAddressSection,
    verified,
    rejectionComment = null,
  } = props;

  const radioProps = [
    {
      label: t(`${PATH}/yes`),
      value: "yes",
    },
    {
      label: t(`${PATH}/no`),
      value: "no",
    },
  ];

  const _onPress = (value) => {
    setSameAddress(value);
  };

  const title = !disableAddressSection
    ? t(`${PATH}/yourDeliveryAddAndAadharAddSame`)
    : `डिलीवरी एड्रेस ${verified ? "वेरीफाई हो चुका है" : ""}`;

  return (
    <View style={styles.addressContainer}>
      <Comment kycComment={rejectionComment} />
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {verified && (
          <CheckIcon
            fill="rgba(0,171,89,1)"
            size={20}
            style={{ marginRight: 5 }}
          />
        )}
        <Text>{title}</Text>
      </View>
      {!disableAddressSection && (
        <RadioForm
          formHorizontal={true}
          animation={false}
          style={{
            fontSize: 14,
            flexDirection: "row",
            justifyContent: "flex-start",
            marginVertical: 0,
            paddingVertical: 0,
            alignItems: "center",
          }}
        >
          {radioProps.map((obj, i) => (
            <RadioButton
              labelHorizontal={true}
              key={obj.label}
              style={{
                marginTop: 15,
                backgroundColor: "rgba(0,0,0,0.05)",
                padding: 8,
                borderRadius: 50,
                marginRight: 40,
                borderColor:
                  obj.value === sameAddress ? colors.primary : "transparent",
                borderWidth: 1,
                minWidth: 78,
                justifyContent: "space-between",
              }}
            >
              {/*  You can set RadioButtonLabel before RadioButtonInput */}
              <RadioButtonLabel
                obj={obj}
                index={i}
                labelHorizontal={true}
                onPress={_onPress}
                labelStyle={{ color: "black", textAlign: "center" }}
                labelWrapStyle={{}}
              />

              <RadioButtonInput
                obj={obj}
                index={i}
                isSelected={obj.value === sameAddress}
                onPress={_onPress}
                borderWidth={2.5}
                buttonInnerColor="#e74c3c"
                buttonOuterColor={
                  obj.value === sameAddress ? colors.primary : "#000"
                }
                buttonSize={10}
                buttonOuterSize={22}
                buttonStyle={{}}
                buttonWrapStyle={{ marginLeft: 10 }}
              />
            </RadioButton>
          ))}
        </RadioForm>
      )}
      {userAddress ? (
        <View
          style={{
            borderRadius: 10,
            backgroundColor: "rgba(0,0,0,0.05)",
            paddingHorizontal: 15,
            paddingVertical: 10,
            marginTop: 10,
            borderWidth: 1,
            borderColor: "rgba(0, 0, 0, 0.1)",
          }}
        >
          <Text
            style={{
              color: "rgba(0,0,0,0.56)",
              marginBottom: 5,
            }}
          >
            {t(`${PATH}/deliveryAdd`)}
          </Text>

          <Text
            style={{
              fontFamily: "Mukta-SemiBold",
            }}
          >
            {userAddress}
          </Text>
        </View>
      ) : (
        <Pressable
          onPress={navigateToTLAddress}
          style={{
            borderRadius: 10,
            backgroundColor: "rgba(0,0,0,0.05)",
            paddingHorizontal: 15,
            paddingVertical: 10,
            marginTop: 20,
            justifyContent: "space-between",
            flexDirection: "row",
            borderWidth: 1,
            borderColor: "rgba(0, 0, 0, 0.1)",
          }}
          android_ripple={{ color: "rgba(0,0,0,0.08)", borderless: false }}
        >
          <Text
            style={{
              fontSize: 16,
            }}
          >
            {t(`${PATH}/enterYourDeliveryAdd`)}
          </Text>
          <CaretIcon strokeColor={colors.primary} />
        </Pressable>
      )}
      {userAddress && sameAddress === "no" ? (
        <AddressProof
          {...{
            uploadAddressProof,
            removeAddressProof,
            addressPhoto,
            disableAddressSection,
          }}
        />
      ) : null}
    </View>
  );
};

const AddressProof = (props) => {
  const {
    addressPhoto,
    uploadAddressProof,
    removeAddressProof,
    disableAddressSection,
  } = props;
  const { source = "" } = addressPhoto;
  return (
    <View style={{ marginTop: 30 }}>
      {!disableAddressSection && (
        <>
          <Text>{t(`${PATH}/deliveryAddProof`)}</Text>
          <Text
            style={{
              fontSize: 12,
              color: "rgba(0,0,0,0.56)",
              marginTop: 5,
              marginBottom: 10,
            }}
          >
            {t(`${PATH}/addExample`)}
          </Text>
        </>
      )}
      <View style={{ alignSelf: "flex-start" }}>
        <Photo
          source={source}
          ctaText={t(`${PATH}/enterAddProof`)}
          onUpload={uploadAddressProof}
          onDelete={removeAddressProof}
          disabled={disableAddressSection}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  addressContainer: {
    marginTop: 30,
    marginBottom: 10,
  },
});

export default AddressSection;
